export const checkForNullable = (object: object): boolean =>
  Object.values(object).every((v) =>
    v && typeof v === 'object'
      ? checkForNullable(v)
      : v !== null && v !== undefined,
  )
